// This is has been created to hold Global Variables that are related to Surfaces and Tool restrictions that are manually implemented in the Code.
// The Variables describe the specific interactions with Surfaces and Tool Types. It will be Split by: VIEW and have a comment on what each Variable does.

// Dashboard
export const SPROUT_DASHBOARD_DATA = [
    { name: 'Hardness', unit: 'Gravs' },
    { name: 'Coverage', unit: '%' },
    { name: 'NDVI', unit: '' },
    { name: 'Compaction', unit: 'MPa' },
    { name: 'Moisture', unit: '%' },
]; // Name and Unit of each of the items within the dashboard


// Image Analysis
export const RELEVANT_TOOL_TYPE_IDS = [12, 16, 17]; //Tool Types that are related to images that combine RGB/IR/RED/MIX

export const TOOL_IMAGE_CONFIG: { [key: number]: { Image1: string, Image2: string, Image3: string, Image4: string,Image5: string, Image6: string } } = {
    12: { Image1: 'RGBCropped', Image2: 'IRCropped', Image3: 'REDCropped', Image4: 'NDVICropped', Image5: 'GreenM', Image6: 'YellowM'  },
    16: { Image1: 'RGBCropped', Image2: 'IRCropped', Image3: 'REDCropped', Image4: 'NDVICropped', Image5: 'GreenM', Image6: 'YellowM' },
    17: { Image1: 'RGBCropped', Image2: 'IRCropped', Image3: 'REDCropped', Image4: 'NDVICropped', Image5: 'GreenM', Image6: 'YellowM' }
};// Define the dynamic configuration for each toolTypeId

// Reports - Square Sports Surfaces

// Reports - Agricultural Surfaces
export const PENETROMETER_BANDS = [
    { min: 0, max: 100 },
    { min: 100, max: 200 },
    { min: 200, max: 300 },
    { min: 300, max: 400 },
    { min: 400, max: 500 },
    { min: 500, max: 600 },
];

export const PENETROMETER_GRAPH_COLOUR_SCALES = [
    getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim(),
    getComputedStyle(document.documentElement).getPropertyValue('--quaternary-color').trim(),
    getComputedStyle(document.documentElement).getPropertyValue('--quainary-color').trim(),
    // getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim(),
    getComputedStyle(document.documentElement).getPropertyValue('--tertiary-color').trim(),
    '#A6DCA9', '#6FB8A1', '#4A9292', '#386C79', '#2F4858', '#FFFFFF',
];


export const RASTER_MAP_API_GATEWAY_URL = 'https://vyb60kpxsb.execute-api.eu-west-2.amazonaws.com/default'; // Raster Map Lambda Function URL


// Sidebar Navigation Items
// Role codes: 'admin' = Company Admin, 'user' = Standard User, 'viewer' = View Only
// isMasterOnly: true = only users with isMaster flag can access
// requiresVehicles: true = only visible when the selected company has at least one vehicle device
export const TOP_BAR_ITEM_AND_RESTRICTIONS: Array<{
    path: string;
    label: string;
    roles: string[];
    isMasterOnly?: boolean;
    requiresVehicles?: boolean;
}> = [
    { path: '/dashboard', label: 'Dashboard', roles: ['admin', 'user'] },
    { path: '/reports', label: 'Reports', roles: ['admin', 'user'] },
    { path: '/saved-reports', label: 'Saved reports', roles: ['admin', 'user', 'viewer'] },
    { path: '/measurement-list', label: 'Measurement list', roles: ['admin', 'user'] },
    { path: '/devices', label: 'Devices', roles: ['admin', 'user'] },
    { path: '/operations', label: 'Operations', roles: ['admin'], requiresVehicles: true },
    { path: '/areas', label: 'Areas', roles: ['admin', 'user'] },
    { path: '/patterns', label: 'Patterns', roles: ['admin', 'user'] },
    { path: '/measurements', label: 'Measurement setup', roles: ['admin', 'user'] },
    { path: '/slam-maps', label: 'SLAM maps', roles: ['admin', 'user'] },
    // Settings entry is now in the sidebar footer (Change Company / Settings / Logout)
];
